export default __webpack_public_path__ + "static/media/women.7d2f96ab.png";